export default "__VITE_ASSET__4vGh4fvK__"